/* Mints scroll showcase. No scroll listeners that block, no wheel/touch handlers, no preventDefault:
   the page scrolls natively; a sticky stage + requestAnimationFrame only READS scroll position. */
(function () {
  var root = document.getElementById('spms');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canvas = root.querySelector('canvas');
  var ctx = canvas && canvas.getContext && canvas.getContext('2d');
  if (reduce || !ctx) return;                                  // final still + copy, normal height

  var N = parseInt(root.dataset.frames, 10) || 60;
  var mobile = window.matchMedia('(max-width:820px)').matches;
  var tpl = mobile ? root.dataset.mobile : root.dataset.desktop;
  /* theme build: explicit per-frame URL lists (Shopify asset URLs carry their own ?v=) in a JSON script tag */
  var LIST = null; try { var le = root.querySelector('script[type="application/json"]'); if (le) { var lj = JSON.parse(le.textContent); LIST = mobile ? lj.m : lj.d; if (LIST && LIST.length) N = LIST.length; } } catch (e) {}
  var W = mobile ? 840 : 1200, H = mobile ? 720 : 900;
  canvas.width = W; canvas.height = H;
  var copy = root.querySelector('.spms-copy');
  var frames = new Array(N), loaded = new Array(N), started = false, drawn = -1, lastCopy = -1;

  function url(i) { if (LIST) return LIST[i]; var s = String(i + 1); while (s.length < 3) s = '0' + s; return tpl.replace('{n}', s); }
  function load(i) {
    if (frames[i]) return;
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { loaded[i] = true; if (drawn === -1 || i === want) tick(true); };
    im.src = url(i);
    frames[i] = im;
  }
  function loadRest() {
    if (started) return; started = true;
    // last frame early (it is the resting state), then the rest in order
    load(N - 1);
    var i = 1;
    (function next() { for (var k = 0; k < 6 && i < N - 1; k++) load(i++); if (i < N - 1) setTimeout(next, 60); })();
  }
  function nearest(i) {                                       // nearest LOADED frame to i (never a blank canvas)
    for (var d = 0; d < N; d++) {
      if (i - d >= 0 && loaded[i - d]) return i - d;
      if (i + d < N && loaded[i + d]) return i + d;
    }
    return -1;
  }
  var want = 0;
  function progress() {
    var r = root.getBoundingClientRect(), vh = window.innerHeight;
    /* progress starts before the stage pins: when the section top reaches 35 % of the viewport */
    var lead = vh * 0.35, total = r.height - vh + lead;
    return total <= 0 ? 1 : Math.min(1, Math.max(0, (lead - r.top) / total));
  }
  function tick(force) {
    var p = progress();
    // frames play over the first 64 % of the scroll distance, the copy fades in over the next 21 % (full by 85 %),
    // and the rest holds the finished product shot + copy before the stage unpins
    want = Math.min(N - 1, Math.round(Math.min(1, p / 0.64) * (N - 1)));
    var i = nearest(want);
    if (i !== -1 && (i !== drawn || force)) { ctx.drawImage(frames[i], 0, 0, W, H); drawn = i; }
    var c = Math.min(1, Math.max(0, (p - 0.64) / 0.21));     // copy fades in 64 % -> 85 %
    c = Math.round(c * 100) / 100;
    if (c !== lastCopy) {
      root.style.setProperty('--spms-copy', c);
      copy.classList.toggle('is-off', c < 0.5);
      lastCopy = c;
    }
  }
  var raf = 0;
  function loop() { tick(false); raf = requestAnimationFrame(loop); }

  root.classList.add('is-scroll');
  load(0);                                                     // first frame immediately
  if ('IntersectionObserver' in window) {
    // preload the rest once the section is within one viewport; run the rAF loop only while it is near
    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { loadRest(); if (!raf) loop(); }
      else if (raf) { cancelAnimationFrame(raf); raf = 0; tick(true); }
    }, { rootMargin: '100% 0px 100% 0px' }).observe(root);
  } else { loadRest(); loop(); }
  // keyboard / assistive tech: when the button gets focus, make sure the copy is visible
  root.querySelector('.spms-btn').addEventListener('focus', function () {
    var r = root.getBoundingClientRect();
    window.scrollTo(0, window.pageYOffset + r.top + r.height - window.innerHeight);
  });
})();
